// src/services/constructionService.js
import { supabase } from './supabase';

const FALLBACK_STORAGE_KEY = 'nobrokerage_construction_services_fallback';
const STORAGE_BUCKET = 'property-images';

export const CONSTRUCTION_CATEGORIES = [
  'Civil Construction',
  'Electrical & Plumbing',
  'Piping Works',
  'Fitting & Panel Works',
  'Painting & Finishing'
];

export const INITIAL_CONSTRUCTION_SERVICES = [
  {
    id: 'c0000000-0000-0000-0000-000000000001',
    category: 'Civil Construction',
    name: 'Civil Construction',
    description: 'Makan aur dukan ki majboot buniyad, RCC column-beam schedule aur brickwork/plaster ka mukammal civil kaam.',
    icon: 'Hammer',
    image_url: 'https://images.unsplash.com/photo-1541888946425-d0fbb18615f3?auto=format&fit=crop&w=800&q=80',
    priority: 1,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000002',
    category: 'Electrical & Plumbing',
    name: 'Electrical Work',
    description: 'Concealed wiring, MCB distribution board setup, inverter connection aur safety earthing ka professional kaam.',
    icon: 'Zap',
    image_url: 'https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&w=800&q=80',
    priority: 2,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000003',
    category: 'Electrical & Plumbing',
    name: 'Plumbing Work',
    description: 'Bathroom & kitchen sanitary fittings, leak-proof line fixing aur overhead water tank installation.',
    icon: 'Wrench',
    image_url: 'https://images.unsplash.com/photo-1585704032915-c3400ca199e7?auto=format&fit=crop&w=800&q=80',
    priority: 3,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000004',
    category: 'Fitting & Panel Works',
    name: 'PVC Panel Fitting',
    description: 'Deewaron aur ceiling ke liye 100% waterproof, termite-free aur designer decorative PVC panel installation.',
    icon: 'Layers',
    image_url: 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?auto=format&fit=crop&w=800&q=80',
    priority: 4,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000005',
    category: 'Fitting & Panel Works',
    name: 'ACP Fitting',
    description: 'Modern showroom aur building exterior front facade ke liye weather-proof ACP sheet cladding aur framing.',
    icon: 'Building2',
    image_url: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80',
    priority: 5,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000006',
    category: 'Fitting & Panel Works',
    name: 'SS Fitting',
    description: 'Balcony railing, staircase handrails aur designer gates ke liye rust-proof high-grade Stainless Steel fitting.',
    icon: 'ShieldCheck',
    image_url: 'https://images.unsplash.com/photo-1590381105924-c72589b9ef3f?auto=format&fit=crop&w=800&q=80',
    priority: 6,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000007',
    category: 'Painting & Finishing',
    name: 'Painting / Colour Work',
    description: 'Double-coat putty, primer, interior luxury emulsion aur exterior weather-shield paint finishing ka kaam.',
    icon: 'Paintbrush',
    image_url: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?auto=format&fit=crop&w=800&q=80',
    priority: 7,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000008',
    category: 'Piping Works',
    name: 'CPVC Piping',
    description: 'Garam aur thande paani (hot & cold water) supply ke liye high-temperature durable CPVC pipe network.',
    icon: 'Pipette',
    image_url: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?auto=format&fit=crop&w=800&q=80',
    priority: 8,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000009',
    category: 'Piping Works',
    name: 'UPVC Piping',
    description: 'Potable drinking water supply aur underground distribution ke liye lead-free chemical-resistant UPVC piping.',
    icon: 'Boxes',
    image_url: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&w=800&q=80',
    priority: 9,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  },
  {
    id: 'c0000000-0000-0000-0000-000000000010',
    category: 'Piping Works',
    name: 'SWR Piping',
    description: 'Soil, Waste aur Rainwater drainage ke liye ring-fit leak-proof heavy-duty SWR pipeline setup.',
    icon: 'Store',
    image_url: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=800&q=80',
    priority: 10,
    status: 'Active',
    show_in_footer: true,
    created_at: new Date().toISOString()
  }
];

const getLocalFallback = () => {
  try {
    const raw = localStorage.getItem(FALLBACK_STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed) && parsed.length > 0) return parsed;
    }
  } catch (e) {
    console.error('Error reading construction services fallback storage:', e);
  }
  return INITIAL_CONSTRUCTION_SERVICES;
};

const setLocalFallback = (list) => {
  try {
    localStorage.setItem(FALLBACK_STORAGE_KEY, JSON.stringify(list));
  } catch (e) {
    console.error('Error saving construction services fallback storage:', e);
  }
};

/**
 * In-browser canvas image compression
 */
export const compressImage = (file, maxWidth = 1200, quality = 0.85) => {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith('image/')) {
      return reject(new Error('Selected file must be an image.'));
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        let width = img.width;
        let height = img.height;

        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob(
          (blob) => {
            if (!blob) {
              return reject(new Error('Canvas compression failed'));
            }
            resolve(blob);
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = () => reject(new Error('Failed to load image for compression'));
    };
    reader.onerror = () => reject(new Error('Failed to read image file'));
  });
};

/**
 * Upload image to Supabase Storage
 */
export const uploadServiceImage = async (file) => {
  const compressedBlob = await compressImage(file, 1200, 0.85);
  const ext = 'jpg';
  const fileName = `construction-${Date.now()}-${Math.random().toString(36).substring(2, 8)}.${ext}`;
  const filePath = `construction/${fileName}`;

  const { error: uploadError } = await supabase.storage
    .from(STORAGE_BUCKET)
    .upload(filePath, compressedBlob, {
      contentType: 'image/jpeg',
      cacheControl: '31536000',
      upsert: false
    });

  if (uploadError) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(compressedBlob);
    });
  }

  const { data } = supabase.storage.from(STORAGE_BUCKET).getPublicUrl(filePath);
  return data.publicUrl;
};

/**
 * Fetch all construction services
 */
export const fetchConstructionServices = async () => {
  try {
    const { data, error } = await supabase
      .from('construction_services')
      .select('*')
      .order('priority', { ascending: true })
      .order('created_at', { ascending: false });

    if (error || !data || data.length === 0) {
      return getLocalFallback();
    }

    setLocalFallback(data);
    return data;
  } catch (err) {
    console.warn('Using local fallback for construction services:', err);
    return getLocalFallback();
  }
};

/**
 * Add a new construction service
 */
export const addConstructionService = async (item) => {
  const newRecord = {
    category: item.category || 'Civil Construction',
    name: item.name.trim(),
    description: item.description.trim(),
    icon: item.icon || 'Hammer',
    image_url: item.image_url || null,
    priority: Number(item.priority) || 0,
    status: item.status || 'Active',
    show_in_footer: item.show_in_footer !== false,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString()
  };

  try {
    const { data, error } = await supabase
      .from('construction_services')
      .insert([newRecord])
      .select()
      .single();

    if (!error && data) {
      const current = getLocalFallback();
      setLocalFallback([data, ...current]);
      return data;
    }
  } catch (err) {
    console.warn('Supabase insert failed, applying local fallback:', err);
  }

  // Fallback
  const fallbackRecord = { ...newRecord, id: `local-${Date.now()}` };
  const current = getLocalFallback();
  const updated = [fallbackRecord, ...current];
  setLocalFallback(updated);
  return fallbackRecord;
};

/**
 * Update a construction service
 */
export const updateConstructionService = async (id, updates) => {
  const cleanUpdates = {
    ...updates,
    updated_at: new Date().toISOString()
  };

  try {
    const { data, error } = await supabase
      .from('construction_services')
      .update(cleanUpdates)
      .eq('id', id)
      .select()
      .single();

    if (!error && data) {
      const current = getLocalFallback();
      const updated = current.map(item => item.id === id ? data : item);
      setLocalFallback(updated);
      return data;
    }
  } catch (err) {
    console.warn('Supabase update failed, applying local fallback:', err);
  }

  // Fallback
  const current = getLocalFallback();
  const updated = current.map(item => item.id === id ? { ...item, ...cleanUpdates } : item);
  setLocalFallback(updated);
  return updated.find(item => item.id === id);
};

/**
 * Toggle active/inactive status
 */
export const toggleServiceStatus = async (id, currentStatus) => {
  const newStatus = currentStatus === 'Active' ? 'Inactive' : 'Active';
  return updateConstructionService(id, { status: newStatus });
};

/**
 * Toggle footer visibility
 */
export const toggleFooterVisibility = async (id, currentVal) => {
  return updateConstructionService(id, { show_in_footer: !currentVal });
};

/**
 * Delete a construction service
 */
export const deleteConstructionService = async (id) => {
  try {
    const { error } = await supabase
      .from('construction_services')
      .delete()
      .eq('id', id);

    if (error) {
      console.warn('Supabase delete error:', error);
    }
  } catch (err) {
    console.warn('Supabase delete failed, applying local fallback:', err);
  }

  const current = getLocalFallback();
  const updated = current.filter(item => item.id !== id);
  setLocalFallback(updated);
  return true;
};
